var map = {
	"./billing/features.svg": 3479,
	"./commercial/features.svg": 8133,
	"./facilities/features.svg": 8761,
	"./facilities/functionalities.svg": 876,
	"./parc/beneficts.svg": 2555,
	"./parc/decisions.svg": 6405,
	"./parc/description.svg": 8135,
	"./parc/destinations.svg": 569,
	"./parc/functionalities.svg": 5820
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5685;